import React from 'react';

export const payrollDeductionColumns = [
  {
    name: <span className="font-weight-bold fs-13">Proposta</span>,
    sortable: true,
    width: '10%',
    selector: (row) => row.number,
  },
  {
    name: <span className="font-weight-bold fs-13">Matrícula</span>,
    selector: (row) => row.registration,
    width: '10%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Nome do Titular</span>,
    selector: (row) => row.customer_name,
    width: '20%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">CPF</span>,
    selector: (row) => row.cpf,
    width: '15%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Data da Venda</span>,
    selector: (row) => row.sale_at,
    width: '10%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Vigência</span>,
    selector: (row) => row.effective_date,
    width: '10%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Plano</span>,
    selector: (row) => row.plan_name,
    width: '10%',
    sortable: true,
  },
];
